
import BubbleIcon from '@/components/interface/BubbleIcon.vue';
import { Icon } from '@/lib/enum/Icon';
import { showInfo } from '@/plugins/ToastNotifications';
import { MenuItemType } from '@/types/propTypes';
import { PropType } from 'vue';

/**
 * For use inside a <BottomSheet /> component to fill the items
 * e.g. if using different components for the list inside MobileHeader
 */
export default {
  name: 'BottomSheetInsert',
  components: { BubbleIcon },
  props: {
    list: {
      type: Array as PropType<MenuItemType[]>,
      required: true,
    },
  },

  data() {
    return {
      Icon,
    };
  },

  methods: {
    onDisabledClick(message: MenuItemType['disabled']) {
      if (typeof message === 'string' && message.length) {
        showInfo(message, this.$t('toastNotification.disabledAction'));
      }
    },
  },
};
